/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Status_OpenInputs */

const en_claim_status_open = /** @type {(inputs: Claim_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening the ticket`)
};

/**
* | output |
* | --- |
* | "Opening the ticket" |
*
* @param {Claim_Status_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_status_open = /** @type {((inputs?: Claim_Status_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Status_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_status_open(inputs)
});